<template>
   <div>
      <b-container>
         <PageTitle title="Questionnaires" />
      </b-container>
      <QuestionnaireAnswerForm v-if="loaded" @refresh="fetchData" />
   </div>
</template>

<script>
import QuestionnaireAnswerForm from './widgets/QuestionnaireAnswerForm.vue';
import {mapGetters} from 'vuex';

export default {
   name: 'CompanyQuestionnaireAnswer',

   components: {
      QuestionnaireAnswerForm,
   },

   data() {
      return {
         loaded: false,
      };
   },

   computed: {
      ...mapGetters({
         activeStudyId: 'companies/activeStudyId',
         hasQuestionnaireAssignment: 'progress/hasQuestionnaireAssignment',
      }),

      companyId() {
         return this.$route.params.id;
      },

      questionnaireId() {
         return this.$route.params.questionnaireId;
      },
   },

   methods: {
      // Load the questionnaire data
      async fetchData() {
         let requests = [];

         requests.push(
            this.$store.dispatch('questionnaire/loadCompanyQuestionnaire', {
               questionnaireId: this.questionnaireId,
            })
         );

         requests.push(this.$store.dispatch('users/loadCompanyUsers', {companyId: this.companyId}));
         requests.push(
            this.$store.dispatch('questionnaire/loadQuestionnaires', {companyId: this.companyId})
         );

         await this.loadPage(requests);
         this.loaded = true;
      },
   },

   async created() {
      await this.fetchData();
   },

   watch: {
      async activeStudyId() {
         if (this.isActiveStudyInSetupStage) {
            this.$router.push({name: 'Home'});
            return;
         }
         if (!this.hasQuestionnaireAssignment) {
            this.$router.push({name: 'Home'});
         } else {
            this.loaded = false;
            await this.fetchData();
         }
      },
   },
};
</script>
